import type { DELIVERY_METHODS } from 'my-purchases/constants/deliveryMethods'
import { ORDER_STATUS } from 'my-purchases/constants/orderStatus'
import type { PAYMENT_TYPES } from 'my-purchases/constants/paymentTypes'
import { getBOPOKey } from 'my-purchases/utils/getBOPOKey'

interface GetStatusLabelsProps {
	status: ORDER_STATUS
	deliveryMethod?: DELIVERY_METHODS | null
	paymentMethod?: PAYMENT_TYPES | null
}

export const getStatusLabels = ({
	status,
	deliveryMethod,
	paymentMethod,
}: GetStatusLabelsProps) => {
	const getStatusTitle = () => {
		if (status === ORDER_STATUS.delivered && deliveryMethod) {
			return `${status}_${deliveryMethod}`
		}
		return status
	}

	return {
		detailsLabel: `myPurchases.online.details.status_${status}.label`,
		desktopDetails: `myPurchases.online.desktop.details.status_${getStatusTitle()}.title${getBOPOKey(
			status,
			paymentMethod
		)}`,
	}
}
